module.exports = __webpack_public_path__ + "static/media/Nairobi.39f104cd.png";